import { mutationOptions } from '@tanstack/react-query'

import { QueryKeys } from '@/configs/query'
import type { ApiError } from '@/lib/api/api-error'
import { siteApi } from '@/lib/api/site-client'
import type { ContactFormPayload } from '@/lib/contact/contact-form-schema'

export type SubmitContactResponse = unknown

export const submitContactMutation = () =>
  mutationOptions<SubmitContactResponse, ApiError, ContactFormPayload>({
    mutationKey: [...QueryKeys.CONTACT, 'submit'],
    mutationFn: async (payload) => {
      const body = {
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        phone: payload.phone,
        company: payload.company,
        businessAddress: payload.businessAddress,
        locationScale: payload.locationScale,
        inquiryType: payload.inquiryType,
        message: payload.message,
      }
      const requestBody = { data: body }

      try {
        const data = await siteApi.post<unknown>({
          url: '/api/contacts',
          data: requestBody,
        })
        return data
      } catch (error) {
        throw error
      }
    },
  })
